module.exports = __webpack_public_path__ + "img/octagon-plus.29cb80c1.svg";